import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface BusinessInfoStepProps {
  onNext: (data: Record<string, any>) => void;
  data?: Record<string, any>;
  isLastStep?: boolean;
}

export const BusinessInfoStep: React.FC<BusinessInfoStepProps> = ({ onNext, data = {} }) => {
  const [businessName, setBusinessName] = useState(data.business_name || '');
  const [businessType, setBusinessType] = useState(data.business_type || 'service');
  const [description, setDescription] = useState(data.description || '');
  const [address, setAddress] = useState(data.address || '');
  const [website, setWebsite] = useState(data.website || '');

  const handleContinue = () => {
    onNext({ 
      business_name: businessName || 'Empresa Demo',
      business_type: businessType,
      description,
      address,
      website,
      configured: true 
    });
  };

  // Não requeremos realmente o preenchimento para simplificar o fluxo
  // O objetivo é apenas mostrar um formulário realista

  return (
    <Card className="border-none shadow-none">
      <CardHeader>
        <CardTitle>Informações do Negócio</CardTitle>
        <CardDescription>
          Preencha as informações básicas sobre sua empresa
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-4">
          <div className="grid gap-2">
            <Label htmlFor="business_name">Nome da Empresa</Label>
            <Input
              id="business_name"
              placeholder="Sua Empresa Ltda."
              value={businessName}
              onChange={(e) => setBusinessName(e.target.value)}
            />
          </div>
          
          <div className="grid gap-2">
            <Label htmlFor="business_type">Tipo de Negócio</Label>
            <Select value={businessType} onValueChange={setBusinessType}>
              <SelectTrigger>
                <SelectValue placeholder="Selecione o tipo de negócio" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="service">Prestação de Serviços</SelectItem>
                <SelectItem value="retail">Comércio / Varejo</SelectItem>
                <SelectItem value="food">Alimentação</SelectItem>
                <SelectItem value="healthcare">Saúde</SelectItem>
                <SelectItem value="education">Educação</SelectItem>
                <SelectItem value="other">Outro</SelectItem>
              </SelectContent>
            </Select>
          </div>
          
          <div className="grid gap-2">
            <Label htmlFor="description">Descrição do Negócio</Label>
            <Textarea
              id="description"
              placeholder="Descreva brevemente sua empresa e serviços..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </div>
          
          <div className="grid gap-2">
            <Label htmlFor="address">Endereço</Label>
            <Input
              id="address"
              placeholder="Endereço completo"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          
          <div className="grid gap-2">
            <Label htmlFor="website">Website</Label>
            <Input
              id="website"
              placeholder="https://www.seusite.com.br"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>
        </div>

        <div className="flex justify-end pt-4 space-x-2">
          <Button variant="outline" onClick={() => window.history.back()}>
            Voltar
          </Button>
          <Button onClick={handleContinue}>
            Continuar
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}; 